export const ADMINS_LISTS_ROUTES = {
    ADMINS_LIST: "/admins",
    ROLES_LIST: "/roles",
};